import { Typography } from "@earned/core";

interface YAxisTickProps {
  x: number;
  y: number;
  width: number;
  height: number;
  payload: {
    value: number;
  };
  tickFormatter: (value: number) => string;
}

const YAxisTick = (props: YAxisTickProps) => {
  return (
    <svg>
      <foreignObject
        x={props.x - 30}
        y={props.y - 10}
        width={props.width}
        height={props.height}
      >
        <Typography variant="body-sm" color="secondary">
          {props.tickFormatter(props.payload.value)}
        </Typography>
      </foreignObject>
    </svg>
  );
};

export default YAxisTick;
